<template>
  <p class="vouchers-list-item-empty">
    There are no attempts associated with this voucher.
  </p>
</template>

<script>
export default {
  name: 'VouchersListItemAttemptEmpty',
}
</script>

<style lang="scss">
.vouchers-list-item-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 50px 25px;
  border: 1px solid var(--perfect-gray);
  border-radius: 10px;
  color: var(--perfect-gray);
  margin: 20px 0;
  @include tablet {
    margin: 0;
    padding: 75px 50px;
  }
  @include desktop {
    padding: 75px 100px;
  }
}
</style>
